<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场地名称：</span>
        </div>
        <el-input v-model="formData.placeName" size="small" style="width: 280px" />
      </div>
      <div class="form-line" style="display: flex;justify-content: flex-start;margin: 10px 0 0 0">
        <div class="textBox" >
          <span class="line-text">场地图片：</span>
        </div>
        <!--<upload-img-list @getImgList="getImgList"  />-->
        <input id="uploadGuidedGraph" name="file" accept="image/*" type="file"
               @change="upData2" style="display: none" />
        <div>
          <a class="newly2" @click="upImg2" v-if="!formData.placePic">
            <span><i class="el-icon-plus"></i></span>
            <span>点击上传</span>
          </a>
          <a class="upload2" @click="upImg2" v-if="formData.placePic">
            <img :src="formData.placePic" id="packBg" />
            <b>重新上传</b>
          </a>
        </div>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场地位置：</span>
        </div>
        <el-input v-model="formData.location" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">场地所在楼层：</span>
        </div>
        <el-cascader v-model="formData.floorCode" :options="buildingList" size="small" style="width: 280px" @change="floorChange"></el-cascader>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">场地描述：</span>
        </div>
        <el-input v-model="formData.description" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">场地设施：</span>
        </div>
        <el-transfer filterable :filter-method="filterMethod" filter-placeholder="请输入场地设施" :titles="['可选设施', '已选设施']" v-model="formData.equipmentCodeList" :data="equipmentList"></el-transfer>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">关联门禁：</span>
        </div>
        <el-select v-model="accessCodeArr" placeholder="请选择" multiple size="small" style="width: 280px;">
          <el-option
            v-for="item in deviceList"
            :key="item.deviceCode"
            :label="item.deviceName"
            :value="item.deviceCode">
          </el-option>
        </el-select>
        <!--<input-device-site-tree :fetch="fetchDetail" :maxDepth="4" :showPopBox="true" @input="getAccessCtrlList" style="width: 280px" />-->
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">是否收费：</span>
        </div>
        <el-switch v-model="isFreeState" active-text="是" inactive-text="否"></el-switch>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费方式：</span>
        </div>
        <el-switch v-model="payMethodState" active-text="线上" inactive-text="线下"></el-switch>
      </div>
      <div class="form-line" v-if="isFreeState">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">收费价格：</span>
        </div>
        <div style="flex-direction: column;align-items: flex-start;">
          <div v-for="(item, index) in formData.priceUnit" :key="index" style="margin-bottom: 10px;">
            <el-input v-model="item.money" size="small" style="width: 138px" placeholder="单价" >
              <template slot="append">元</template>
            </el-input>
            <el-input v-model="item.unit" size="small" style="width: 138px" placeholder="时长">
              <template slot="append">小时</template>
            </el-input>
            <i class="el-icon-remove-outline" style="line-height: 32px;font-size: 18px;color: #f25721;margin: 0 0 0 10px;cursor: pointer;" @click="removePriceUnitItem(index)" v-if="index > 0"></i>
            <i class="el-icon-circle-plus-outline" style="line-height: 32px;font-size: 18px;color: #00A0E6;margin: 0 10px 0 10px;cursor: pointer;" @click="addPriceUnitItem(index)" v-if="index === formData.priceUnit.length - 1"></i>
          </div>
        </div>
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="formData.memo" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">责任人：</span>
        </div>
        <el-select v-model="responsiblePersonCode"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod"
                   placeholder="请输入关键词查询">
          <el-option v-for="item in responsiblePersonList" :key="item._value"
                     :label="item._label" :value="item._value">
          </el-option>
        </el-select>
        <span v-html="responsiblePersonVer"></span>
      </div>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import TextTitle from '../../../components/Text/TextTitle'
import ButtonConfirm from '../../../components/Button/ButtonConfirm'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import {api} from '../../api/SiteReservation'
import {treeApi} from '../../api/TreeApi'
import {errorHandler} from '../../../utils/errorHandler'
import {nError, nSuccess} from '../../../utils/notice'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import InputDeviceSiteTree from '../../../components/common/inputs/input-device-site-tree'

export default {
  components: {
    InputDeviceSiteTree,
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb},
  name: 'site-modify',
  data () {
    return {
      breadcrumb: [{
        value: '智慧预约',
        name: 'site-management'
      }, {
        value: '场地管理'
      }],
      mainTitle: '修改场地',
      subheading: '修改场地信息及收费标准',
      payTypeList: [{
        key: '0',
        label: '不收费'
      }, {
        key: '1',
        label: '按小时收费'
      }, {
        key: '2',
        label: '按天收费'
      }],
      deviceList: [],
      accessCodeArr: [],
      accessNameArr: [],
      responsiblePersonCode: '',
      responsiblePersonList: [],
      responsiblePersonVer: '<span>责任人可接收场地预约通知</span>',
      isFreeState: false,
      payMethodState: false,
      equipmentList: [],
      buildingList: [],
      formData: {
        placeName: '',
        placePic: '',
        location: '',
        description: '',
        accessCodes: '',
        accessNames: '',
        payType: '0',
        unitHour: '',
        unitDay: '',
        responsiblePersonCode: '',
        memo: '',
        isFree: 0,
        payMethod: '0',
        priceUnit: [
          {money: '', unit: ''},
        ],
        equipmentCodeList: [],

        buildingName: '',
        buildingCode: '',
        floorName: '',
        floorCode: '',
      }
    }
  },
  created () {
    this.currentCode = this.$route.params.id
    this.getEquipmentList()
    this.getDeviceTreeForVenue()
    this.getPlaceByCode()
    this.remoteMethod()
    this.getBuildingList()
  },
  methods: {
    remoteMethod (query) {
      this.getResponsiblePersonList(query)
    },

    getBuildingList () {
      this.$axios.post(api.getBuildingList, {})
        .then(res => {
          let data = res.data.data
          data.map(v => {
            v.value = v.code
            v.label = v.name
            if (v.floors) {
              v.floors.map(floor => {
                floor.value = floor.code
                floor.label = floor.name
              })
            }
            v.children = v.floors
          })
          this.buildingList = data
        })
        .catch(errorHandler('获取楼栋列表失败'))
    },

    floorChange (val) {
      this.buildingList.map(v => {
        if (v.value === val[0]) {
          this.formData.buildingCode = v.value
          this.formData.buildingName = v.name
        }
        v.children.map(floor => {
          if (floor.value === val[1]) {
            this.formData.floorCode = floor.value
            this.formData.floorName = floor.name
          }
        })
      })
    },

    // 获取责任人列表
    getResponsiblePersonList (searchKey) {
      this.$axios.post(api.getResponsiblePersonList, {
        searchKey: searchKey || ''
      })
        .then(res => {
          let list = res.data.data
          list.forEach(it => {
            it._value = it.code
            it._label = `${it.name} / ${it.phone}`
          })
          this.responsiblePersonList = list
        })
        .catch(errorHandler('获取责任人列表失败'))
    },
    getDeviceTreeForVenue () {
      treeApi.getDeviceTreeForVenue()
        .then(list => {
          this.deviceList = list
        })
    },
    getEquipmentList () {
      this.$axios.get(api.getEquipmentList, {})
        .then(res => {
          let list = res.data.data
          list.forEach(it => {
            it.key = it.code
            it.label = `${it.equipmentName}(${it.price}${it.unit})`
          })
          this.equipmentList = list
        })
        .catch(errorHandler('获取设施列表失败'))
    },
    filterMethod(query, item) {
      return item.label.indexOf(query) > -1;
    },
    upData2: function () {
      let that = this
      const oFReader = new FileReader()
      const file = document.getElementById('uploadGuidedGraph').files[0]
      if (file.size > 1024 * 1024) {
        nError('上传图片不能大于1M')
        return false
      }
      oFReader.readAsDataURL(file)
      oFReader.onloadend = function (oFRevent) {
        const src = oFRevent.target.result
        that.pictureBase64 = src
        that.uploadPicture()
      }
    },
    upImg2: function () {
      document.getElementById('#uploadBackgroundImg')
      $('#uploadGuidedGraph')
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on('change', function () {
          // const objUrl = getObjectURL(this.files[0])
          // if (objUrl) {
          //   $('#pic2').attr('src', objUrl)
          // }
        })
    },

    // 上传图片
    uploadPicture () {
      this.$axios.post(api.uploadImg, {
        picData: this.pictureBase64
      })
        .then(res => {
          if (res.data.retCode === 1) {
            this.formData.placePic = res.data.data
          } else {
            // 提示信息，需引入Message
            nError('图片上传失败')
          }
        })
        .catch(errorHandler('图片上传失败'))
    },
    toSiteManagement () {
      this.$router.push({
        name: 'site-management'
      })
    },
    // getAccessCtrlList (roomNameStr, roomCodeStr, roomAreaStr) {
    //   this.formData.accessCodes = roomCodeStr
    //   this.formData.accessNames = roomNameStr
    // },
    getPlaceByCode () {
      this.$axios.get(`${api.getPlaceByCode}/${this.currentCode}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.responsiblePersonCode = data.responsiblePersonCode
            this.formData = data
            if (data.isFree === 0) {
              this.isFreeState = false
            } else {
              this.isFreeState = true
            }
            if (data.payMethod === '0') {
              this.payMethodState = false
            } else {
              this.payMethodState = true
            }
            if (data.accessCodes) {
              this.accessCodeArr = data.accessCodes.split(',')
            } else {
              this.accessCodeArr = []
            }
            if (data.accessNames) {
              this.accessNameArr = data.accessNames.split(',')
            } else {
              this.accessNameArr = []
            }
          }
        })
        .catch(errorHandler('查询场地失败'))
    },
    // 增加收费价格
    addPriceUnitItem (index) {
      if (!this.formData.priceUnit[index].money || !this.formData.priceUnit[index].unit) {
        nError('请先填写当前收费价格')
        return false
      }
      let obj = {
        money: '',
        unit: '',
      }
      this.formData.priceUnit.push(obj)
    },

    // 删减收费价格
    removePriceUnitItem (index) {
      this.formData.priceUnit.splice(index, 1)
    },
    confirm () {
      if (this.isFreeState) {
        this.formData.isFree = 1
      } else {
        this.formData.isFree = 0
      }
      if (this.payMethodState) {
        this.formData.payMethod = 1
      } else {
        this.formData.payMethod = 0
      }
      if (!this.formData.placeName) {
        nError('请输入场地名称')
        return false
      }
      if (!this.formData.location) {
        nError('请输入场地位置')
        return false
      }
      if (this.formData.isFree === 1 && this.formData.priceUnit.length === 1) {
        if (!this.formData.priceUnit[0].unit || !this.formData.priceUnit[0].money) {
          nError('请输入收费价格')
          return false
        }
      }
      this.formData.responsiblePersonCode = this.responsiblePersonCode
      this.responsiblePersonList.map(v => {
        if (v.code === this.responsiblePersonCode) {
          this.formData.responsiblePersonName = v.name
          this.formData.responsiblePersonPhone = v.phone
        }
      })
      this.accessNameArr = []
      this.deviceList.map(v => {
        this.accessCodeArr.map(code => {
          if ( v.deviceCode === code) {
            this.accessNameArr.push(v.deviceName)
          }
        })
      })
      this.formData.accessCodes = this.accessCodeArr.join(',')
      this.formData.accessNames = this.accessNameArr.join(',')
      this.$axios.post(api.updatePlaceByCode, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.toSiteManagement()
          }
        })
        .catch(errorHandler('修改场地失败'))
    },
    cancel () {
      this.toSiteManagement()
    }
  }
}
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: middle;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    line-height: 30px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }

  .newly2 {
    display: inline-block;
    width: 160px;
    height: 90px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    border-radius: 5px;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 50px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 30px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 160px;
    height: 90px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    border-radius: 5px;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    opacity: .7;
  }
</style>



// WEBPACK FOOTER //
// src/view/SiteReservation/SiteManagement/SiteModify.vue